import React, { useEffect, useState } from 'react';
import { FiLogOut } from 'react-icons/fi';
import { useKeycloak } from '@react-keycloak/web';

const NavBar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const { keycloak } = useKeycloak();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={[
        'fixed top-0 left-[250px] right-0 h-14 z-30 flex items-center px-4',
        'bg-gray-100 border-b border-gray-200 transition-shadow duration-200',
        scrolled ? 'shadow-md' : '',
      ].join(' ')}
    >
      <div className="ml-auto">
        <button
          onClick={() => void keycloak.logout()}
          className="flex items-center gap-2 px-4 py-2 bg-red-600 text-white
                     rounded hover:bg-red-700 active:bg-red-800
                     transition-colors duration-150 text-sm font-medium"
        >
          <FiLogOut size={18} />
          Sign Out
        </button>
      </div>
    </header>
  );
};

export default NavBar;
